export let addToFavoritesCategoryText = "s_0P9c";
export let addToFavoritesCategoryTextTeams = "OmREce";
export default {addToFavoritesCategoryText,addToFavoritesCategoryTextTeams};